<template>
	<div>
		<div class="flex-center px-4">
			<!-- Payment Receipt -->
			<div v-if="receipt">
				<div class="text-bold" v-if="showTitle">Payment Receipt</div>
				<div
					class="payment-receipt-image"
					:style="{ backgroundImage: `url('${receipt.value}')` }"
					@click.stop="showImage(receipt.value)">
				</div>
			</div>
		</div>
		<div class="modals">
			<!-- Transfer Receipt Viewer -->
			<modal
				class=""
				size="medium"
				type="lightbox"
				@close="isPopupVisible = false"
				v-if="isPopupVisible">
				<div slot="header"><h3>Payment Receipt</h3></div>
				<div slot="body" class="text-center">
					<img class="w-100" :src="url">
				</div>
				<template slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isPopupVisible = false">
						Close
					</button>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'WalletHistoryMetas',
	props: {
		metas: {
			type: Array,
			default: () => [],
		},
		showTitle: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			url: '',
			isPopupVisible: false,
		};
	},
	methods: {
		showImage(url) {
			this.url = url;
			this.isPopupVisible = true;
		},
	},
	computed: {
		receipt() {
			const metas = duplicateVar(this.metas);
			const receipt = metas.sort((a, b) => b.id - a.id).find(({ key }) => key === 'receipt');
			return receipt;
		},
	},
};
</script>
